import React, { useState } from "react";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import Avatar from "@mui/material/Avatar";
import MenuIcon from "@mui/icons-material/Menu"; // Import a hamburger icon
import "../styles/components/_header.css";
import { logout } from "../service/auth.service";

const Header = ({ onSidebarToggle }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);

  

  return (
    <div className="header">
      <div className="header-left">
        <button className="sidebar-toggle" onClick={onSidebarToggle}>
          <MenuIcon className="menu-icon" />
        </button>
        <div className="brand-container">
          <h1 className="app-title">SEA TECH MARINE</h1>
          <span className="app-subtitle">Service Management</span>
        </div>
      </div>
      <div className="header-right">
        <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
          <DropdownToggle tag="div" className="profile-icon">
            <Avatar src={""} alt={"Logo"} />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem onClick={() => logout()}>Logout</DropdownItem>
          </DropdownMenu>
        </Dropdown>
      </div>
    </div>
  );
};

export default Header;
